import './search.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {ChangeLanguage, GetBlogCount, GetSearch} from "../../redux/actions";
import {connect} from "react-redux";
import BlogCard from "../../components/uiElements/cards/blogCard/BlogCard";
import {Pagination} from "antd";
import {PageLeftArrIcon, PageRightArrIcon} from "../../assets/images";
import {PAGE_NEWS_COUNT} from "../../constants/constType";
import {useRef, useState} from "react";


function Search(props) {
    const {staticTexts,search,blogCount} = props
    const [currentPage, setCurrentPage] = useState(1);
    const isFetching = useRef(false)
    console.log(search,'search')

    async function onChangePaging (news) {
        let count = news -1
        isFetching.current = true;
        const configInfo = {
            reset: true,
            offset: count * PAGE_NEWS_COUNT,
            limit: PAGE_NEWS_COUNT,
        }
        await props.GetSearch(configInfo)
        await props.GetBlogCount(configInfo)
        setCurrentPage(news);
        window.scrollTo({
            top: 0
        });
    }

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a className={'prev_btn'}>
                <PageLeftArrIcon/>
            </a>;
        }
        if (type === 'next') {
            return <a className={'next_btn'}>
                <PageRightArrIcon/>
            </a>;
        }
        return originalElement;
    };

    return <div className={'search-page-wrapper'}>
        <div className={'search-page-header'}>
            <div className={'search-page-title'}>
                {staticTexts?.search_page_title}
            </div>
            {
                search?.length ? <div className={'search-page-total'}>
                    {search?.length} <span>{staticTexts?.search_page_total}</span>
                </div> : ''
            }
        </div>
        {
             search?.length ? <div className={'search-page-result'}>
                {
                    search?.map(item => {
                        return <div className={'search-page-card'}>
                            <BlogCard item={item}/>
                        </div>
                    })
                }
            </div> : <div className={'search-page-notResult'}>
                {staticTexts?.search_page_notResult}
            </div>
        }

        <Pagination current={currentPage}
                    defaultPageSize={6}
                    onChange={onChangePaging}
                    itemRender={itemRender}
                    hideOnSinglePage={true}
                    className={`pagination`}
                    total={blogCount || 0}/>
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'languages',
        'selectedLanguage',
        'search',
        'blogCount',
    ])
};
const mapDispatchToProps = {
    ChangeLanguage,
    GetSearch,
    GetBlogCount
};
export default connect(mapStateToProps,mapDispatchToProps)(Search);